import { render } from "./message-file.vue?vue&type=template&id=316b94e5&scoped=true&ts=true"
import script from "./message-file.vue?vue&type=script&lang=ts"
export * from "./message-file.vue?vue&type=script&lang=ts"

import "./message-file.vue?vue&type=style&index=0&id=316b94e5&lang=scss&scoped=true"

import exportComponent from "/home/gitlab-runner/builds/3Mswgxxg/0/im/im-web/iguopin-chat/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-316b94e5"]])

export default __exports__